import React from 'react';

import { components } from 'react-select';
import { MenuListProps } from 'react-select/dist/declarations/src/components/Menu';

import { useMyCustomSelectorStatus } from 'store/myCustomSelect.store';

import classes from 'components/common/MyCustomSelect/components/MenuList/MenuList.module.scss';

import { Switch } from 'components/DesignSystem/Switch';

export const MenuList = <T,>({ children, ...rest }: MenuListProps<T>) => {
    const { showOnlyAliasStatus, update } = useMyCustomSelectorStatus();

    const toggleSwitch = () => {
        update({ showOnlyAliasStatus: !showOnlyAliasStatus });
    };

    const filteredChildren = React.Children.toArray(children).filter((child: any) => child.props.data?.value.alias);

    const filteredChildrenFinal =
        filteredChildren.length === 0 ? (
            <components.NoOptionsMessage {...rest}>No options</components.NoOptionsMessage>
        ) : (
            filteredChildren
        );

    return (
        <div>
            <div className={classes.menuListSwitchContainer}>
                <Switch
                    checked={showOnlyAliasStatus}
                    onChange={toggleSwitch}
                    label={'Show only activity codes with aliases'}
                    labelPlacement={'start'}
                />
            </div>
            <components.MenuList {...rest}>
                {showOnlyAliasStatus ? filteredChildrenFinal : children}
            </components.MenuList>
        </div>
    );
};
